define('cart/cartOperations',[
    "common/formUtils",
    "common/alertMessage",
    "common/spinner"
],
    function (formUtils, alertMessage, spinner) {
        function addItemToCart(itemCode, quantity, notes, details, okCallback, errorCallback) {
            var postData = buildCartItemPayload(itemCode, quantity, notes, details);
            $.ajax({
                type: "POST",
                url: "/customapi/Cart/AddItemToCart",
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "OK") {
                        okCallback();
                    } else if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                        if (errorCallback)
                            errorCallback();
                    }
                },
                error: function (jq, status, errorThrown) {
                    alertMessage.error(status + ": " + errorThrown);
                    if (errorCallback)
                        errorCallback();
                },
                complete: function () {

                }
            });
        }

        function updateCartItem(cartItemId, itemCode, quantity, details, okCallback, errorCallback) {
            var postData = buildCartItemPayload(itemCode, quantity, null, details);
            postData.cartItemId = cartItemId;
            $.ajax({
                type: "POST",
                url: "/customapi/Cart/UpdateCartItem",
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "OK") {
                        okCallback();
                    } else if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                        if (errorCallback)
                            errorCallback();
                    }
                },
                error: function (jq, status, errorThrown) {
                    alertMessage.error(status + ": " + errorThrown);
                    if (errorCallback)
                        errorCallback();
                },
                complete: function () {

                }
            });
        }

        function setCartItemQuantity(cartItemId, quantity, spinnerSelector, callback) {
            var postData = {
                cartItemId: cartItemId,
                quantity: quantity
            };
            formUtils.useToken(postData);
            spinner.show(spinnerSelector);
            $.ajax({
                type: "POST",
                url: "/customapi/Cart/SetCartItemQuantity",
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                    }
                    callback(data.status, data.message, data);
                },
                error: function (jq, status, errorThrown) {
                    var message = status + ": " + errorThrown;
                    alertMessage.error(message);
                    callback("ERROR", message, null);
                },
                complete: function () {
                    spinner.hide(spinnerSelector);
                }
            });
        }

        function setCartItemNotes(cartItemId, notes, spinnerSelector, callback) {
            var postData = {
                cartItemId: cartItemId,
                notes: notes
            };
            formUtils.useToken(postData);
            spinner.show(spinnerSelector);
            $.ajax({
                type: "POST",
                url: "/customapi/Cart/SetCartItemNotes",
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                    }
                    callback(data.status, data.message, data);
                },
                error: function (jq, status, errorThrown) {
                    var message = status + ": " + errorThrown;
                    alertMessage.error(message);
                    callback("ERROR", message, null);
                },
                complete: function () {
                    spinner.hide(spinnerSelector);
                }
            });
        }

        function removeItemFromCart(cartItemId, spinnerSelector, callback) {
            var postData = {
                cartItemId: cartItemId
            };
            formUtils.useToken(postData);
            spinner.show(spinnerSelector);
            $.ajax({
                type: "POST",
                url: "/customapi/Cart/RemoveItemFromCart",
                dataType: "json",
                data: postData,
                success: function (data) {
                    if (data.status === "ERROR") {
                        alertMessage.error(data.message);
                    }
                    callback(data.status, data.message, data);
                },
                error: function (jq, status, errorThrown) {
                    var message = status + ": " + errorThrown;
                    alertMessage.error(message);
                    callback("ERROR", message, null);
                },
                complete: function () {
                    spinner.hide(spinnerSelector);
                }
            });
        }

        function buildCartItemPayload(itemCode, quantity, notes, details) {
            var data = {
                input: {
                    ItemCode: itemCode,   // string
                    Quantity: quantity,   // int
                    Notes: notes,         // string
                    Details: details      // an array of DetailCode and Quantity pairs (e.g. [{DetailCode: "ABC", Quantity: 2},{DetailCode: "XYZ", Quantity: 1}])
                }
            };
            formUtils.useToken(data);
            return data;
        }

        return {
            addItemToCart: addItemToCart,
            updateCartItem: updateCartItem,
            setCartItemQuantity: setCartItemQuantity,
            setCartItemNotes: setCartItemNotes,
            removeItemFromCart: removeItemFromCart
        }
    }
);

